import React from "react";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import FormCreateAccount from "../../components/FormCreateAccount/FormCreateAccount";

const ManageAccountPageCreate = () => {
  return (
    <AppContainer title="Create User Account">
      <center>
        <div style={{ margin: "20px 0px", width: "80vw" }}>
          <FormCreateAccount />
        </div>
      </center>
    </AppContainer>
  );
};

export default ManageAccountPageCreate;
